module.exports = __webpack_public_path__ + "static/fonts/snow-10fecd1906e0aea6a055e5dcf894b588.svg";